module.exports = __webpack_public_path__ + "img/dashboardAdd.f4bc0dfd.png";